// export const BASEURL = "http://localhost:8000/v1/"
// export const BASEURL1 = "http://localhost:8000/"
// export const BASEURL = "http://173.208.96.2:8000/v1/"
// export const BASEURL1 = "http://173.208.96.2:8000/"
// export const BASEURL = "http://172.16.2.98:8000/v1/"
export const BASEURL = "https://tdbackend.fasreports.com/v1/"
// export const BASEURL = "http://172.16.0.69:8003/v1/"
// export const BASEURL = "http://172.16.2.18:8001/v1/"
// export const BASEURL = "http://172.16.0.69:8000/v1/"
// export const BASEURL = "http://172.16.2.133:8000/v1/"
// export const BASEURL = "http://172.16.0.180:8000/v1/"
//
// export const BASEURL = "https://backend.dl1961.com/v1/"
export const BASEURL1 = "https://tdbackend.fasreports.com/"

